type RentListing = { intent?: string; rentHold?: { let?: boolean; until?: string } | null } | null | undefined;

export function rentedOutUntil(property: RentListing): Date | null {
  const hold = property?.intent === "long lease" ? property.rentHold : null;
  const until = hold?.let ? Date.parse(hold.until || "") : NaN;
  return Number.isFinite(until) && until > Date.now() ? new Date(until) : null;
}

export function formatAvailableFrom(date: Date): string {
  return date.toLocaleDateString("en-NG", { day: "numeric", month: "long", year: "numeric" });
}
